"use client";

import { Select as SelectPrimitive } from "@base-ui/react/select";
import { MoonIcon, SunIcon, SunMoonIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem } from "@/components/ui/select";
import { useTheme } from "@/components/theme-provider";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const getIcon = () => {
    if (theme === "dark") {
      return <MoonIcon className="text-muted-foreground" />;
    }
    if (theme === "light") {
      return <SunIcon className="text-muted-foreground" />;
    }
    // Default to system icon for "system" or undefined (during hydration)
    return <SunMoonIcon className="text-muted-foreground" />;
  };

  return (
    <Select
      value={theme || "system"}
      onValueChange={(value) => value && setTheme(value)}
    >
      <SelectPrimitive.Trigger
        render={
          <Button variant="ghost" size="icon" aria-label="Toggle theme" />
        }
      >
        <span className="sr-only">Toggle theme</span>
        {getIcon()}
      </SelectPrimitive.Trigger>
      <SelectContent align="end">
        <SelectItem value="system">
          <span className="flex items-center gap-3">
            <SunMoonIcon className="h-4 w-4" />
            Follow system theme
          </span>
        </SelectItem>
        <SelectItem value="light">
          <span className="flex items-center gap-3">
            <SunIcon className="h-4 w-4" />
            Light theme
          </span>
        </SelectItem>
        <SelectItem value="dark">
          <span className="flex items-center gap-3">
            <MoonIcon className="h-4 w-4" />
            Dark theme
          </span>
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
